import React from 'react';
import MUIAlert, { AlertProps as MUIAlertProps } from '@material-ui/lab/Alert';

import Icon from '../Icon';

interface AlertProps extends MUIAlertProps {}

const Alert = (props: AlertProps) => {
  return (
    <MUIAlert
      {...props}
      iconMapping={{
        error: <Icon name="Cancel" />,
        success: <Icon name="CheckCircle" />,
        warning: <Icon name="ReportProblemRounded" />,
      }}
    >
      {props.children}
    </MUIAlert>
  );
};

Alert.displayName = 'Alert';

export default Alert;
